export const SLACK_NOTIFICATION_FIELDS = [
	"followUpMessageNotificationsEnabled",
	"assignmentChangesNotificationsEnabled",
	"commentCreatedNotificationsEnabled",
	"newThreadNotificationsEnabled",
	"aiHandoffNotificationsEnabled",
	"commentMentionsNotificationsEnabled",
	"unassignedThreadReplyNotificationsEnabled",
	"docsProposalNotificationsEnabled",
	"slaAtRiskNotificationsEnabled",
	"slaBreachedNotificationsEnabled",
] as const

export const EMAIL_NOTIFICATION_FIELDS = [
	"newThreadNotificationsEnabled",
	"aiHandoffNotificationsEnabled",
	"assignedThreadsReplyReceivedNotificationsEnabled",
	"commentMentionsNotificationsEnabled",
	"assignmentChangesNotificationsEnabled",
	"unassignedThreadsReplyReceivedNotificationsEnabled",
	"changelogEmailsEnabled",
	"upvoteEmailsEnabled",
	"docsProposalEmailsEnabled",
] as const

export type SlackNotificationField = (typeof SLACK_NOTIFICATION_FIELDS)[number]
export type EmailNotificationField = (typeof EMAIL_NOTIFICATION_FIELDS)[number]

type SlackFlags = Partial<Record<SlackNotificationField, boolean | undefined>>
type EmailFlags = Partial<Record<EmailNotificationField, boolean | undefined>>

export function buildToggleAllPayload<T extends string>(
	fields: readonly T[],
	value: boolean,
): Partial<Record<T, boolean>> {
	const payload: Partial<Record<T, boolean>> = {}
	for (const field of fields) payload[field] = value
	return payload
}

export function isSlackNotificationsEnabled(
	settings: SlackFlags | null | undefined,
): boolean {
	if (!settings) return false
	return SLACK_NOTIFICATION_FIELDS.some((field) => settings[field] === true)
}

export function isEmailNotificationsEnabled(
	user: EmailFlags | null | undefined,
): boolean {
	if (!user) return false
	return EMAIL_NOTIFICATION_FIELDS.some((field) => user[field] === true)
}
